module.exports = __webpack_public_path__ + "static/media/0008.b5abeb97.jpg";